<div class="main-container" #popperError="popper" [popper]="tooltipErrTemplate"
    [popperDisabled]="!propertyViewModel.hasErrors || propertyViewModel?.securityAccess != null"
    [popperTrigger]="ngxPopperjsTriggers.hover" popperApplyClass="error" [popperPlacement]="ngxPopperjsPlacements.TOP"
    [popperPreventOverflow]="false" [popperHideOnScroll]="true" [class.fullscreen]="fullscreen" popperAppendTo="body">
    <p-editor [disabled]="!propertyViewModel.isEnabled" #message [class.has-error]="propertyViewModel.hasErrors"
        [modules]="modules" [class.no-toolbar]="!showToolbar" [(ngModel)]="propertyViewModel.value"
        [readonly]="!propertyViewModel.isEnabled" [placeholder]="placeHolder" class="editor">
        <ng-template pTemplate="header">
            <span class="ql-formats" *ngIf="showToolbar">
                <select class="ql-size" [title]="'Size'" [disabled]="!propertyViewModel.isEnabled">
                    <option selected></option>
                    <!-- <option value="13px">Normal</option> -->
                    <option value="0.75em">Small</option>
                    <option value="1.5em">Large</option>
                    <option value="2.5em">Huge</option>
                </select>
                <select class="ql-header" [title]="'Heading'" [disabled]="!propertyViewModel.isEnabled">
                    <option selected></option>
                    <option value="1"></option>
                    <option value="2"></option>
                    <option value="3"></option>
                    <option value="4"></option>
                    <option value="5"></option>
                    <option value="6"></option>
                </select>
                <select class="ql-color" [disabled]="!propertyViewModel.isEnabled"></select>
                <select class="ql-background" [disabled]="!propertyViewModel.isEnabled"></select>
                <select class="ql-font" [disabled]="!propertyViewModel.isEnabled">
                    <option selected></option>
                    <!-- <option value="sans-serif">San Serif</option> -->
                    <option value="serif">Serif</option>
                    <option value="monospace">Monospace</option>
                </select>
                <select class="ql-align" [disabled]="!propertyViewModel.isEnabled"></select>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-bold" aria-label="Bold"
                    tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-italic" aria-label="Italic"
                    tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-underline"
                    aria-label="Underline" tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-strike" aria-label="Strike"
                    tabindex="-1"></button>
                <button class="ql-list" [disabled]="!propertyViewModel.isEnabled" value="ordered"
                    tabindex="-1"></button>
                <button class="ql-list" [disabled]="!propertyViewModel.isEnabled" value="bullet" tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-link" aria-label="Link"
                    tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-image" aria-label="Image"
                    tabindex="-1"></button>
                <button type="button" [disabled]="!propertyViewModel.isEnabled" class="ql-clean" aria-label="Clean"
                    tabindex="-1"></button>
                <button *ngIf="fullscreen && enableFullscreen" [disabled]="!propertyViewModel.isEnabled" type="button"
                    (click)="toggleFullscreen.emit()" class="pi pi-window-minimize" aria-label="Minimize"
                    tabindex="-1"></button>
                <button *ngIf="!fullscreen && enableFullscreen" [disabled]="!propertyViewModel.isEnabled" type="button"
                    (click)="toggleFullscreen.emit()" class="pi pi-window-maximize" aria-label="Maximize"
                    tabindex="-1"></button>
            </span>
        </ng-template>
    </p-editor>
</div>
<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of propertyViewModel.getErrors()">
        {{ item }}
    </ng-container>
</popper-content>
<!-- https://github.com/quilljs/quill/issues/1432 -->
